import '../../modules/mode-components';

import * as angular from 'angular';

class SignupEmailInputController {
  public email: string;
}

const SignupEmailInputComponent: angular.IComponentOptions = {
  bindings: {
    email: '@',
  },
  template: `
<input type="email" name="email" id="email" class="form-control"
  autofocus="autofocus"
  placeholder="you@youremail.com"
  ng-model="ctrl.email"
>
`,
  controller: SignupEmailInputController,
  controllerAs: 'ctrl',
};

angular.module('mode.components').component('signupEmailInput', SignupEmailInputComponent);
